// Work package "experts": experts (staff) and the expert portal.
// This folder belongs to the WP (docs/v3/WORKPACKAGES.md 4). Other areas may
// import what this file exports (read-only use); they never edit this folder.
import { extra, page, screen, type AreaRoute } from "../../routes/types";

export const routes: AreaRoute[] = [
  // 5. Experts (staff)
  screen(68, page(() => import("./pages/ExpertsPage"), "ExpertsPage")),
  screen(69, page(() => import("./pages/TimesheetsPage"), "TimesheetsPage")),
  screen(70, page(() => import("./pages/TimesheetPage"), "TimesheetPage")),
  screen(71, page(() => import("./pages/CorrectLinePage"), "CorrectLinePage")),
  screen(72, page(() => import("./pages/AssignmentsPage"), "AssignmentsPage")),
  screen(73, page(() => import("./pages/AssignExpertPage"), "AssignExpertPage")),
  screen(74, page(() => import("./pages/SelectionPage"), "SelectionPage")),
  screen(75, page(() => import("./pages/NeedPage"), "NeedPage")),
  screen(76, page(() => import("./pages/RequirementsPage"), "RequirementsPage")),
  // EX9: "New expert need" opens the form; the need is made on save.
  extra("/p/:projectId/experts/selection/new", page(() => import("./pages/RequirementsPage"), "NewNeedPage")),
  screen(77, page(() => import("./pages/CandidatePage"), "CandidatePage")),
  screen(78, page(() => import("./pages/ExpertContractPage"), "ExpertContractPage")),
  screen(79, page(() => import("./pages/WorkloadPage"), "WorkloadPage")),
  screen(80, page(() => import("./pages/ExpertPage"), "ExpertPage")),
  screen(81, page(() => import("./pages/AddExpertPage"), "AddExpertPage")),
  screen(82, page(() => import("./pages/EditExpertPage"), "EditExpertPage")),
  screen(83, page(() => import("./pages/ImportCvsPage"), "ImportCvsPage")),
  // "See as the expert" (from the Expert page; not a sitemap screen of its own)
  extra("/p/:projectId/experts/:id/preview", page(() => import("./pages/ExpertPreviewPage"), "ExpertPreviewPage")),
  // 6. Expert portal
  screen(84, page(() => import("./pages/PortalHomePage"), "PortalHomePage")),
  screen(85, page(() => import("./pages/PortalHoursPage"), "PortalHoursPage")),
  screen(86, page(() => import("./pages/PortalTimesheetPage"), "PortalTimesheetPage")),
  screen(87, page(() => import("./pages/PortalInvoicesPage"), "PortalInvoicesPage")),
  screen(88, page(() => import("./pages/PortalClaimPage"), "PortalClaimPage")),
  screen(89, page(() => import("./pages/PortalContractsPage"), "PortalContractsPage")),
  screen(90, page(() => import("./pages/PortalDetailsPage"), "PortalDetailsPage")),
  screen(91, page(() => import("./pages/PortalMessagePage"), "PortalMessagePage")),
  screen(92, page(() => import("./pages/PortalCvPage"), "PortalCvPage")),
];
